import { render, staticRenderFns } from "./ManagePasswords.vue?vue&type=template&id=f15745d2&"
import script from "./ManagePasswords.vue?vue&type=script&lang=js&"
export * from "./ManagePasswords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports